var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"home-contra"},[_c('el-header',[_c('my-header')],1),_c('el-container',[_c('my-aside'),_c('el-main',{staticStyle:{"background-color":"rgb(238, 241, 246)"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }